import axios from '@/axios.js'

export default {
  getCashBookTemporary () {
    return new Promise((resolve, reject) => {
      axios.get('/cashflow-temporary')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  findCashBookTemporary (context, id) {
    return new Promise((resolve, reject) => {
      axios.get(`/cashflow-temporary/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createCashBookTemporary (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/cashflow-temporary', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateCashBookTemporary (context, payload) {
    return new Promise((resolve, reject) => {
      axios.put(`/cashflow-temporary/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteCashBookTemporary (context, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/cashflow-temporary/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
